import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Description,
  Block,
} from 'components/landing/components';

import HeaderButtons from './HeaderButtons';

const dumbServices = dumbBem('l-services');
const HeaderBlocks = tx([{ element: 'header-blocks' }, dumbServices])('div');

const Header = ({
  title,
  description,
  ...rest
}) => {
  return (
    <Block modifier="header">
      <Title>{title}</Title>
      <Description>{description}</Description>

      <HeaderBlocks>
        <HeaderButtons {...rest} />
      </HeaderBlocks>
    </Block>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/Header.jsx